import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import axiosWithToken from "../../../utils/commonComponent/axiosTokenConfig";
import { BASE_URL, reportLetter, UnicodeCompany } from "../../../global";
import { fetchAddresses, fetchQuery } from "../../../utils/commonComponent/fetched";
import { AddButton, CancelButton, SaveAndUpdate } from "../../../utils/Custom/Button";
import CommonForm from "../../../utils/commonComponent/commonForm";
import Text from "../../../utils/Custom/text";
import { generatePDFQuotation } from "./quotationPrint";
import { AutoCompletes, TextFields } from "../../../utils/Custom/custominput";
import ProductDetails from "../../productDetails/productDetails";
import { generatePDFQuotationLetter } from "./quotationPrintLetter";
import { clienTypes } from "../../../utils/commonComponent/common";
import ChangeHistoryTable from "./changeHistoryTable";
import DownloadPdfLoaderModal from "../../../utils/commonComponent/downloadPdfLoader";
import { getPermissions } from "../rbac/hasAccess";

const gstTypes = [
  { id: 1, label: "State GST" },
  { id: 2, label: "Central Gst" },
  { id: 3, label: "Non Gst" },
];

export const headingTypes = [
  { id: 1, label: "Regular Quotation" },
  { id: 2, label: "Specific Quotation" }
];

let gstPercentageOptions = [
  { id: 18, label: "18" },
  { id: 20, label: "20" },
  { id: 28, label: "28" },
  { id: 15, label: "15" },
];

export default function EditQuotation(props) {
  const params = useParams();
  const permissions = getPermissions(props.moduleId);
  const PrintView = props?.print == true;
  const [inputStates, setInputStates] = React.useState({});
  const [letterHead, setLetterHead] = React.useState(true);
  const [changeHistory, setChangeHistory] = React.useState([]);
  const [downloadPdfloading, setDownloadPdfloading] = React.useState(false);

  const handleChangeHistoryUpdate = (historyData) => {
    setChangeHistory(historyData);
  }

  const [clientList, setClientList] = React.useState([]);
  const [productDetails, setProductDetails] = React.useState([]);
  // New state for address management
  const [availableAddresses, setAvailableAddresses] = React.useState([]);
  const [showAddressSelection, setShowAddressSelection] = React.useState(false);
  const fieldCharLimits = {
    executiveSummary: 900,           /*1000*/
    scopeInspectionLocation: 450,    /*500*/
    scopeOfThirdParty: 450,          /*500*/
    quotationValidity: 270,          /*300*/
    paymentTerms: 900,               /*1000*/

    specialTermsConditions: 630,     /*700*/
    clientScope: 450,                /*500*/
    deliverables: 450,               /*500*/
  };

  const updateInputObject = (key, value) => {
    const limit = fieldCharLimits[key];
    if (limit && typeof value === "string" && value.length > limit) {
      toast.warning(`You have reached the maximum ${limit} allowed text for PDF display `);
      return;
    }
    setInputStates((prevInputStates) => ({
      ...prevInputStates,
      [key]: value,
    }));

    if (key == "gstType") {
      updateQuoObject("gstType", value);
    }
  };

  // Enhanced input fields with conditional address fields
  const getInputFields = () => {
    const baseFields = [
      {
        type: "Autocomplete",
        label: "Quotation Heading",
        stateKey: "quotationType",
        options: headingTypes,
        valueKey: "id",
        getOptionLabelKey: "label",
      },
      {
        type: "Autocomplete",
        label: "Company Name",
        stateKey: "clientId",
        options: clientList,
        valueKey: "id",
        getOptionLabelKey: "label",
        disabled: params.id != 0,
      },
    ];
    // Add address selection fields if multiple addresses are available
    if (
      showAddressSelection &&
      availableAddresses.length > 1 &&
      params.id == 0
    ) {
      baseFields.push(
        {
          type: "Autocomplete",
          label: "Select Billing Address",
          stateKey: "selectedBillingAddressId",
          options: availableAddresses,
          valueKey: "id",
          getOptionLabelKey: "displayAddress",
        },
      );
    }

    // Only show billing text field if NOT multiple address selection OR it's edit mode
    if (
      !showAddressSelection ||
      availableAddresses.length <= 1 ||
      params.id != 0
    ) {
      baseFields.push(
        {
          type: "TextField",
          label: "Billing Address",
          stateKey: "address",
          disabled: true,
        },
      );
    }
    // Add the remaining fields
    baseFields.push(
      {
        type: "TextField",
        label: "Quotation Number",
        stateKey: "quotationNumber",
        disabled: params.id != 0
      },
      { type: "DatePicker", label: "Date *", stateKey: "date" },
      // { type: "Textarea", label: "Subject", stateKey: "subject" },
      {
        type: "Autocomplete",
        label: "GST Type",
        stateKey: "gstType",
        options: gstTypes,
        valueKey: "id",
        getOptionLabelKey: "label",
        disabled: PrintView
      },
      {
        type: "Autocomplete",
        label: "GST Percentage",
        stateKey: "gstpercentages",
        options: gstPercentageOptions,
        valueKey: "id",
        getOptionLabelKey: "label",
        disabled: PrintView
      },
      // {
      //   type: "TextField",
      //   label: "Quotation Validity",
      //   stateKey: "quotationValidity",
      // },
      {
        type: "TextField",
        label: "Client Reference",
        stateKey: "enquiryReference",
        disabled: PrintView
      },
      {
        type: "TextField",
        label: "Ref. No. Enquiry",
        stateKey: "refNoEnquiry",
        disabled: PrintView
      },
      // {
      //   type: "Checkbox",
      //   label: "With Merged Product Quantity",
      //   stateKey: "quantityMerge",
      // },
    );
    return baseFields;
  };

  const fetchClientList = async () => {
    try {
      const query = `select * from clients where status = 1`;
      const clientList = await fetchQuery(query);
      let pushArray = [];
      clientList?.map((client) => {
        pushArray.push({
          id: client.id,
          label: client.companyName + (client.uniCode ? ` (${client.uniCode})` : "") + (client.type ? ` (${clienTypes.find(c => c.value == client.type)?.short || ""})` : ""),
          contact: client.contact,
          address: client.address,
          companyName: client.companyName,
          logopath: client?.logopath,
          gstNumber: client?.gstNumber
        });
      });
      setClientList(pushArray);
    } catch (error) {
      console.error("Error fetching clientList:", error);
    }
  };
  const fetchAllserviceList = async () => {
    try {
      const query = `SELECT pd.*, ii.subcategory AS name FROM productDetails pd LEFT JOIN inspectionItems ii ON pd.equipmentId = ii.id WHERE pd.type = 1 AND pd.referenceId = ${params.id};`;
      const serviceList = await fetchQuery(query);
      setProductDetails(serviceList);
    } catch (error) {
      console.error("Error fetching serviceList:", error);
    }
  };
  const fetchServiceList = async () => {
    try {
      // const query = `SELECT priceList.id, priceList.serviceTypeId,  inspectionItems.subcategory as name, priceList.rate, priceList.priceVariation FROM priceList left JOIN inspectionItems ON priceList.serviceTypeId = inspectionItems.id where priceList.clientId = ${inputStates?.clientId} ;`;

      const query = `SELECT id as serviceTypeId, items, subcategory AS name from inspectionItems;`;
      const serviceList = await fetchQuery(query);
      console.log({ serviceList })
      const parsedList = serviceList.map(item => ({
        ...item,
        priceVariation: item.priceVariation ? JSON.parse(item.priceVariation) : []
      }));
      setFilterProductList(parsedList);
    } catch (error) {
      console.error("Error fetching clientList:", error);
    }
  };
  const fetchClientData = async () => {
    const currentClient = clientList?.find(
      (i) => i.id == inputStates?.clientId
    );
    if (!currentClient) return;
    const contactsArray = JSON.parse(currentClient.contact || "[]");
    const Contactdetails = contactsArray.length > 0 ? contactsArray?.[0] : "";
    try {
      // Fetch all addresses for the client (only billing addresses)
      const addresses = await fetchAddresses(currentClient?.address);

      if (addresses.length === 1) {
        // Single address - auto-populate
        const [currentAddress] = addresses;
        setInputStates((prev) => ({
          ...prev,
          contact: Contactdetails?.contactPersonName || "",
          emailId: Contactdetails?.emailId || "",
          contactNumber: Contactdetails?.contact || "",
          address: currentAddress?.address || "",
          companyName: currentClient?.companyName || "",
          addressId: currentAddress?.id || "",
          logopath: currentClient?.logopath || null,
        }));
        setShowAddressSelection(false);
        setAvailableAddresses([]);
      } else if (addresses.length > 1) {
        // Multiple addresses - show selection
        const formattedAddresses = addresses.map((addr, index) => ({
          id: addr.id,
          address: addr.address,
          displayAddress: `${addr.address?.substring(0, 50)}${addr.address?.length > 50 ? "..." : ""
            }`,
        }));

        setAvailableAddresses(formattedAddresses);
        setShowAddressSelection(true);

        // Set basic client info but leave addresses empty for selection
        setInputStates((prev) => ({
          ...prev,
          contact: Contactdetails?.contactPersonName || "",
          emailId: Contactdetails?.emailId || "",
          contactNumber: Contactdetails?.contact || "",
          companyName: currentClient?.companyName || "",
          ...(params.id == 0 && { addressId: null }),
        }));
      }
    } catch (error) {
      console.error("Error fetching addresses:", error);
    }
  };

  // Handle address selection
  useEffect(() => {
    if (
      inputStates?.selectedBillingAddressId &&
      availableAddresses.length > 0
    ) {
      const selectedAddress = availableAddresses.find(
        (addr) => addr.id === inputStates.selectedBillingAddressId
      );
      if (selectedAddress) {
        setInputStates((prev) => ({
          ...prev,
          address: selectedAddress.address,
          addressId: selectedAddress.id,
        }));
      }
    }
  }, [inputStates?.selectedBillingAddressId, availableAddresses]);


  useEffect(() => {
    if (!inputStates?.clientId) return;
    fetchClientData();
    fetchServiceList();
  }, [inputStates?.clientId]);

  useEffect(() => {
    fetchClientList();
  }, []);

  const [filterProductList, setFilterProductList] = React.useState([]);
  const [uniqueProductsByRange, setUniqueProductsByRange] = React.useState([]);
  const [grandTotal, setGrandTotal] = React.useState(0);
  const userType = localStorage.getItem("type");
  const [productReadingRows, setproductReadingRows] = React.useState([]);

  const [quotationObject, updateQuotationObject] = React.useState({
    totalAmount: "",
    projectContext: "",
    scopeservices: "",
    expenses: "",
    courierCharges: "",
    discount: null,
    discountAmount: "",
    fileUpload: null,
    revisionNumber: null,
  });

  const userName = localStorage.getItem("id");

  var refresh = () => {
    window.location.reload(false);
  };

  const fetchChangeHistory = async () => {
    try {
      const query = `SELECT * FROM changeHistory WHERE quotationId = ${params.id}`;
      const result = await axiosWithToken.post(BASE_URL + "dynamic", { query });

      const formatted = result.data.map((row) => ({
        ...row,
        isNew: false, // existing rows are not new
      }));

      setChangeHistory(formatted);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchquotationtDetails = async () => {
    try {
      const query = `select * from quotation where id = ${params.id}`;
      const [quotation] = await fetchQuery(query);
      const allowedKeys = getInputFields().map((field) => field.stateKey);
      const requiredKeys = [...allowedKeys, "id", "paymentTerms", "termsConditions", "specialTermsConditions", "clientScope", "projectContext", "scopeservices", "deliverables", "executiveSummary", "quotationValidity", "scopeOfThirdParty", "scopeInspectionLocation"];
      // Filter quotation to only include allowed keys
      const filteredQuotation = Object.keys(quotation)
        .filter((key) => requiredKeys.includes(key))
        .reduce((obj, key) => {
          obj[key] = quotation[key];
          return obj;
        }, {});

      // Fetch address using the addressId stored in quotation
      const addressId = filteredQuotation.address;
      if (addressId) {
        const addresses = await fetchAddresses(addressId);
        const address = addresses[0]?.address || null;
        // Add address to filteredQuotation
        filteredQuotation.address = address;
      }
      const revNum = quotation?.revisionNumber;
      const revSuffix = revNum > 0 ? `-Rev-${revNum}` : "";
      filteredQuotation.quotationNumber = `${filteredQuotation.quotationNumber}${revSuffix}`;

      setInputStates(filteredQuotation);
      let newData = {
        ...quotationObject,
        expenses: quotation?.expenses || "",
        courierCharges: quotation?.courierCharges || "",
        discount: quotation?.discount || "",
        fileUpload: quotation?.fileUpload || "",
        revisionNumber: quotation?.revisionNumber ?? 0,
        gstType: quotation?.gstType || 1,
        GSTPercentage: quotation?.gstpercentages || 18,
      };
      updateQuotationObject(newData);
    } catch (error) {
      console.error("Error fetching client:", error);
    }
  };
  useEffect(() => {
    if (params.id == 0) {
      updateInputObject(
        "scopeInspectionLocation",
        "PAN India basis like Mumbai, Pune, Nashik, Nagpur, Aurangabad, Sangli, Kolhapur, Vapi, Surat, Baroda, Ahmadabad, Rajkot, Delhi & NCR region, Chennai, Coimbatore, Trichy, Hyderabad, Banglore, Hosur, Kolkata, Durgapur etc. at major industrial locations."
      );
      updateInputObject(
        "scopeOfThirdParty",
        "AS PER SCOPE FOR 3RD PARTY INSPECTION SERVICESPROJECT TULIP, ISAMBE INDUSTRIAL AREA, SSG provided in the mail.\nThird Party Inspection of various equipment’s & individual items (Stage wise & final Inspections) including PEB will be carried out generally as per approved Quality Assurance Plan (QAP) /drawings/technical specification, PO or Work Order etc. and as per the stages of approved QAP. Client shall provide all the necessary documents to us before start of execution."
      );
      updateInputObject(
        "quotationValidity",
        "Our offer is valid for 90 days from the date of issue and fee will remain firm for 12 months, if contract is signed within 90 days of offer."
      );
      updateInputObject(
        "specialTermsConditions",
        "i) The above quoted fee is applicable only for the defined scope of work under this offer\nii) Our Per Man-day is based on max 8 working hours during normal working days except Sundays & Public Holidays.\niii) Working on Sundays & Holidays will be charged 1.5 times normal charges on prorate basis.\niv) Extra hours other than 8 hours shall be charged 1.25 times normal charges on prorate basis."
      );
      updateInputObject(
        "termsConditions",
        "Quoted services will be executed as per mutually agreed terms and conditions.\n"
      );
      updateInputObject(
        "clientScope",
        "i) Shall provide safe access to the inspection items & availability of suitable/calibrated instruments/equipment etc.\nii) Shall provide all necessary approved details, drawings, specifications, plans, procedures as applicable prior to the commencement of services.\niii) Shall give 2 working days prior notice to deploy our engineers.\niv) Shall nominate a coordinator (employee/representative), who will be single point of contact to DYC Global to execute proposed services."
      );
      let prdefineddeliverables = "We will submit our Inspection Report / Non-Conformity Report in DYC Global format / applicable statutory requirement format (as applicable).\nIf Customer needs reports in any other specific format, the same shall be shared to DYC Global for mutual agreement, before issuance of PO / Service Contract."
      updateInputObject("deliverables", prdefineddeliverables)
      updateInputObject("paymentTerms", `1. We propose to raise our invoice immediately on completion of our scope of work. Our invoices are payable within
 30 days from the date of invoice.
2. GST will be charged extra as applicable (at present 18% on quoted fee) at the time of invoicing as per Government
 of India guidelines from time to time.
3. Travel Charges Rs. /- per visit will be extra
4. Sojourn Charges @Rs /- will be applicable if night stay is required.`)
    }
    if (params.id != 0) {
      fetchChangeHistory();
      fetchquotationtDetails();
      fetchAllserviceList();
    }
  }, [params.id]);

  const handleSubmit = async () => {
    const {
      id, contact, companyName, contactNumber, address, emailId, addressId, selectedBillingAddressId, clientId, logopath,
      quotationNumber: rawQuotationNumber,
      ...restInputStates } = inputStates;

    const cleanQuotationNumber = rawQuotationNumber?.replace(/-Rev-\d+$/, "");
    // Step 1: Validate required fields
    if (!inputStates.quotationType) {
      toast.error("Quotation Heading is required!");
      return; // stop submission
    }
    if (!inputStates.clientId) {
      toast.error("Company Name is required!");
      return; // stop submission
    }

    if (!inputStates.address) {
      toast.error("Address is required!");
      return; // stop submission
    }

    if (!inputStates.date) {
      toast.error("Date is required!");
      return; // stop submission
    }

    if (!productReadingRows || productReadingRows.length === 0) {
      toast.error("Product Details: Add at least one product");
      return;
    }

    const payload = {
      ...restInputStates,
      ...(params.id == 0 && {
        address: inputStates.addressId,
        clientId: inputStates.clientId,
      }),
      date: inputStates.date ? moment(inputStates.date).format("YYYY-MM-DD") : null,
      discount: quotationObject.discount || null,
      createdBy: userName,
      expenses: quotationObject.expenses || null,
      courierCharges: quotationObject.courierCharges || null,
      quotationNumber: cleanQuotationNumber,
      revisionNumber: params.id != 0
        ? Number(quotationObject?.revisionNumber ?? 0) + 1
        : 0,
      totalAmount: grandTotal,
    };

    const requiredKeys = [
      "equipmentId", "description", "rate", "quantity", "discount", "amount", "priceVariation"
    ];

    const sanitizeProducts = (referenceId) =>
      productReadingRows.map(({ id, ...product }) => {
        const sanitized = {};
        requiredKeys.forEach(key => {
          const value = product[key];
          sanitized[key] = value === "" ? null : value ?? null;
        });
        return {
          ...sanitized,
          type: 1,
          referenceId,
        };
      });

    const url = BASE_URL;

    try {
      if (params.id != 0) {
        await axiosWithToken.patch(`${url}quotation/${params.id}`, payload);
        const deleteQuery = `DELETE FROM productDetails WHERE type = 1 AND referenceId = ${params.id}`;
        await axiosWithToken.post(`${url}dynamic`, { query: deleteQuery });
        const AllProducts = sanitizeProducts(params.id);
        await axiosWithToken.post(`${url}productDetails/bulk`, AllProducts);

        // Save new change history entries
        const newHistoryRows = changeHistory?.filter((r) => r.isNew);
        if (newHistoryRows.length > 0) {
          for (let row of newHistoryRows) {
            await axiosWithToken.post(`${url}changeHistory`, {
              quotationId: params.id,
              version: row.version,
              date: row.date ? moment(row.date).format("YYYY-MM-DD") : null,
              description: row.description,
              preparedBy: localStorage.getItem("userName") || "",
            });
          }
        }

        toast("Quotation updated successfully!");
      } else {
        const res = await axiosWithToken.post(`${url}quotation`, payload);
        const insertedID = res.data.insertId;
        const AllProductsWithInsertId = sanitizeProducts(insertedID);
        await axiosWithToken.post(`${url}productDetails/bulk`, AllProductsWithInsertId);

        // Save new change history entries with new quotation ID
        const newHistoryRows = changeHistory?.filter((r) => r.isNew);
        if (newHistoryRows.length > 0) {
          for (let row of newHistoryRows) {
            await axiosWithToken.post(`${url}changeHistory`, {
              quotationId: insertedID,
              version: row.version,
              date: row.date ? moment(row.date).format("YYYY-MM-DD") : null,
              description: row.description,
              preparedBy: localStorage.getItem("userName") || "",
            });
          }
        }

        toast("Quotation created successfully!");
      }

      setTimeout(refresh, 500);
    } catch (error) {
      console.error("Error submitting quotation:", error);
      toast.error("Something went wrong while saving the quotation.");
    }
  };



  const fetchDataAndProcess = async (Id, isMergedProduct) => {
    try {
      let allProducts = [];
      let sqlQuery = {
        query: `SELECT id,referenceId,type,equipmentId,description,rate,quantity,discount,amount,priceVariation FROM productDetails WHERE type = 1 AND referenceId = ${Id}`,
      };

      const response = await axiosWithToken.post(
        BASE_URL + `dynamic`,
        sqlQuery
      );
      allProducts = response.data;

      const processedProducts = isMergedProduct
        ? Object.values(
          allProducts.reduce((acc, obj) => {
            const key = obj.rate + "_" + obj.equipmentId;
            if (acc[key]) {
              acc[key].quantity += obj.quantity;
            } else {
              acc[key] = { ...obj };
            }
            return acc;
          }, {})
        )
        : allProducts;

      setproductReadingRows(processedProducts);
      // setOldProductReading(processedProducts);
    } catch (err) {
      console.error("Error fetching and processing data:", err);
    }
  };

  const updateQuoObject = (key, value) => {
    let newQuoObject = {
      ...quotationObject,
    };
    newQuoObject[key] = value;
    updateQuotationObject({ ...newQuoObject });
  };

  useEffect(() => {
    if (inputStates?.id) {
      fetchDataAndProcess(inputStates?.id, inputStates?.quantityMerge);
    }
  }, [inputStates?.id, inputStates?.quantityMerge]);

  const fetchLAstQuotation = async () => {
    try {
      const query = `select count(1) as count from quotation where status = 1`;
      const result = await fetchQuery(query);
      return result[0]?.count || 0;
    } catch (error) {
      console.error("Error fetching inspection item count:", error);
      return 0;
    }
  };

  useEffect(() => {
    let currentClient = clientList?.find((i) => i.id == inputStates.clientId);
    const generateQuotationNumber = async () => {
      const count = await fetchLAstQuotation();
      const newCount = count + 1;
      let companyNames = currentClient?.companyName?.trim();
      if (companyNames) {
        const words = companyNames.split(/\s+/); // Split by spaces
        if (words.length > 1) {
          // Step 2: If multiple words, take initials
          companyNames = words.map((word) => word[0].toUpperCase()).join("");
        } else {
          // Step 3: If single word, take first 3 letters
          companyNames = companyNames.substring(0, 3).toUpperCase();
        }
      }
      const companyPrefix = UnicodeCompany || reportLetter;
      const quotationNumberCreate = `${companyPrefix}/${companyNames}/25-26/${newCount}`;
      updateInputObject("quotationNumber", quotationNumberCreate);
    };

    if (currentClient?.companyName && params.id == 0) {
      generateQuotationNumber();
    }
    currentClient?.gstNumber &&
      updateInputObject(
        "gstType",
        currentClient.gstNumber.startsWith("27") ? 1 : 2
      );

  }, [params.id, inputStates?.clientId]);

  return (
    <div>
      {!PrintView && (
        <Text variant="h3" bold className="text-blue-600">
          {params.id == 0 ? "Create New Quotation" : `Update Quotation`}
        </Text>
      )}
      {PrintView && (permissions.pdfDownload || permissions.allAccess) && (
        <div className="flex gap-10 mt-5 justify-end ">
          <div className="min-w-[250px]">
            <AutoCompletes
              label="Letter Head"
              options={[
                { id: 1, label: "With Letter Head" },
                { id: 2, label: "Without Letter Head" },
              ]}
              valueKey="id"
              labelKey="label"
              value={letterHead ? 1 : 2}
              onChange={(val) => setLetterHead(val === 1)}
            />
          </div>
          <AddButton
            id="btn-print"
            label="Download PDF"
            onClick={async (e) => {
              if (inputStates?.quotationType == 1) {
                await generatePDFQuotation(
                  inputStates,
                  letterHead,
                  productDetails,
                  quotationObject,
                  filterProductList,
                  setDownloadPdfloading
                );
              } else {
                await generatePDFQuotationLetter(
                  inputStates,
                  letterHead,
                  productDetails,
                  quotationObject,
                  filterProductList,
                  changeHistory,
                  setDownloadPdfloading
                );
              }
            }}
          />
        </div>
      )}
      <br />
      <CommonForm
        inputStates={inputStates}
        updateInputObject={updateInputObject}
        inputFields={getInputFields()}
      />

      <div className="mt-5 grid grid-cols-1 gap-4">
        {inputStates?.quotationType == 2 && (
          <>
            <TextFields
              id="executiveSummary"
              multiline
              label="Executive Summary Description"
              value={inputStates.executiveSummary || ""}
              onChange={(e) =>
                updateInputObject("executiveSummary", e.target.value)
              }
              disabled={PrintView}
            />
            <TextFields
              id="scopeInspectionLocation"
              multiline
              label="Inspection Location"
              value={inputStates.scopeInspectionLocation || ""}
              onChange={(e) => updateInputObject("scopeInspectionLocation", e.target.value)}
              disabled={PrintView}
            />
            <TextFields
              id="scopeOfThirdParty"
              multiline
              label="Scope of ThirdParty Inspection"
              value={inputStates.scopeOfThirdParty || ""}
              onChange={(e) => updateInputObject("scopeOfThirdParty", e.target.value)}
              disabled={PrintView}
            />
          </>
        )}
        <TextFields
          id="quotationValidity"
          multiline
          label="Quotation Validity"
          value={inputStates.quotationValidity || ""}
          onChange={(e) => updateInputObject("quotationValidity", e.target.value)}
          disabled={PrintView}
        />
        <TextFields
          id="paymentTerms"
          multiline
          label="Note"
          value={inputStates.paymentTerms || ""}
          onChange={(e) => updateInputObject("paymentTerms", e.target.value)}
          disabled={PrintView}
        />
        <TextFields
          id="projectContext"
          multiline
          label="Project Context"
          value={inputStates.projectContext || ""}
          onChange={(e) => updateInputObject("projectContext", e.target.value)}
          disabled={PrintView}
        />
        <TextFields
          id="scopeservices"
          multiline
          label="Scope Services"
          value={inputStates.scopeservices || ""}
          onChange={(e) => updateInputObject("scopeservices", e.target.value)}
          disabled={PrintView}
        />
        <TextFields
          id="termsConditions"
          multiline
          label="Terms Conditions"
          value={inputStates.termsConditions || ""}
          onChange={(e) => updateInputObject("termsConditions", e.target.value)}
          disabled={PrintView}
        />
        <TextFields
          id="specialTermsConditions"
          multiline
          label="Special Terms Conditions"
          value={inputStates.specialTermsConditions || ""}
          onChange={(e) => updateInputObject("specialTermsConditions", e.target.value)}
          disabled={PrintView}
        />
        <TextFields
          id="clientScope"
          multiline
          label="Client Scope"
          value={inputStates.clientScope || ""}
          onChange={(e) => updateInputObject("clientScope", e.target.value)}
          disabled={PrintView}
        />
        <TextFields
          id="deliverables"
          multiline
          label="Deliverables"
          value={inputStates.deliverables || ""}
          onChange={(e) => updateInputObject("deliverables", e.target.value)}
          disabled={PrintView}
        />
      </div>

      <br />
      <br />
      {inputStates?.quotationType == 2 && (
        <ChangeHistoryTable quotationId={params.id} disabled={PrintView} onChangeHistoryUpdate={handleChangeHistoryUpdate} changeHistory={changeHistory} setChangeHistory={setChangeHistory} />
      )}

      <br />
      <br />

      <div>
        <ProductDetails
          productArray={filterProductList}
          uniqueProductsByRange={uniqueProductsByRange}
          setproductReadingRows={setproductReadingRows}
          productReadingRows={productReadingRows}
          updateQuoObject={updateQuoObject}
          grandTotal={grandTotal}
          setGrandTotal={setGrandTotal}
          invoiceObject={quotationObject}
          isInvoice={false}
          // setSelectedIds={setSelectedIds}
          disabled={PrintView}
        />
      </div>

      {!PrintView && (
        <div className="flex gap-10 mt-5 justify-end ">
          <CancelButton
            id="btn-cancel"
            label="Cancel"
            outline
            onClick={() => {
              if (window.confirm("Are you sure you want to cancel?")) {
                window.history.back();
              }
            }}
          />
          {(permissions.save || permissions.create || permissions.allAccess) && (
            <SaveAndUpdate
              id="btn-add-outline"
              label={params.id == 0 ? "Save" : "Update"}
              onClick={handleSubmit}
            />
          )}
        </div>
      )}
      {downloadPdfloading && (
        <DownloadPdfLoaderModal
          loading={downloadPdfloading}
          name={"Report"}
        />
      )}
    </div>
  );
}
